import { render } from "./CohortsLoanView.html?vue&type=template&id=624cc7ea"
import script from "./CohortsLoanView.js?vue&type=script&lang=js"
export * from "./CohortsLoanView.js?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__